import { render, staticRenderFns } from "./SendCustomMixNotificationlPopup.vue?vue&type=template&id=5700e41b&scoped=true&"
import script from "./SendCustomMixNotificationlPopup.vue?vue&type=script&lang=js&"
export * from "./SendCustomMixNotificationlPopup.vue?vue&type=script&lang=js&"
import style0 from "./SendCustomMixNotificationlPopup.vue?vue&type=style&index=0&id=5700e41b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5700e41b",
  null
  
)

export default component.exports